module.exports = {"530722101":"永北镇","530722102":"仁和镇","530722103":"期纳镇","530722104":"三川镇","530722105":"程海镇","530722106":"涛源镇","530722107":"鲁地拉镇","530722108":"片角镇","530722109":"顺州镇","530722201":"羊坪彝族乡","530722202":"六德傈僳族彝族乡","530722203":"东山傈僳族彝族乡","530722207":"光华傈僳族彝族乡","530722208":"松坪傈僳族彝族乡","530722209":"大安彝族纳西族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530722.json
// module id = 2728
// module chunks = 0